<div class="row m-0 text-center w-100 py-2 justify-content-center align-items-center alert-banner-container">
  <mat-icon aria-hidden="false" fontIcon="report_problem"></mat-icon>
  <span class='alert-banner-main' [innerHTML]="text"></span>
  <button mat-button class="btn btn-primary my-2 alert-banner-button" (click)="doRouting(ctaUrl)">
    {{ ctaText }}
  </button>
</div>
